import React, { useState, useEffect, useRef } from "react";
import "./PreflightBriefing.css";
import ToggleableNotamList from "./ToggleableNotamList";  // ✅ Adjust path as needed
import { Send, PlayCircle, Printer, Share2 } from "lucide-react";
import ShareFlightModal from './ShareFlightModal';
import resolveRouteWithCoords from "../utils/routeResolver";

import AuthModal from "./AuthModal";
import { useAuth } from "../context/AuthContext";

export default function PreflightBriefing({
  callsign,
  origin,
  destination,
  route,
  altitude,
  tas,
  burnRate,
  filedRoute = [],

  aircraftType,
  cruiseMach,

  zfw,

  mzfw,
  mtow,
  mlw,

  payload,

  originData,
  destinationData,
  enrouteHazards,
  originPireps = [],
  destinationPireps = [],
  onChartSelect,
  selectedChart,


  savedCharts,
  setSavedCharts, 
  taxiOutMinutes = 0,
  taxiInMinutes = 0,
  contingencyMinutes = 0,
  taxiOutBurn = 0,
  taxiInBurn = 0,  
  reserveMinutes = 0,
  reserveBurn = 0,
  contingencyBurn = 0,
  alternateIcao,
  alternateData,
  confirmedRouteString,
  selectedSid,
setSelectedSid,

selectedSidTransition,
setSelectedSidTransition,

selectedStar,
setSelectedStar,

selectedStarTransition,
setSelectedStarTransition,

selectedApproach,
setSelectedApproach,

selectedArrivalRunway,
setSelectedArrivalRunway,

selectedArrivalIAF,
setSelectedArrivalIAF,

availableSids,
sidExits,
sidTransitions,

availableStars,
starTransitions,

availableApproaches,
arrivalRunways,

onStartFlightComplete,

availableIAFs,

updateDepartureProcedure,
updateArrivalProcedure,
selectedSidRunway,
setSelectedSidRunway,

onRequireLogin,

sidRunways,
}) {  
  
  // === NEW: State for charts ===
  const [originCharts, setOriginCharts] = useState({});
  const [destinationCharts, setDestinationCharts] = useState({});
  const [loadingCharts, setLoadingCharts] = useState(false);
  const briefingRef = useRef(null);
  const [hideStickyBar, setHideStickyBar] = useState(false);
  const [showFiledModal, setShowFiledModal] = useState(false);
  const [filedIcaoText, setFiledIcaoText] = useState("");
  const [icaoFlightPlanText, setIcaoFlightPlanText] = useState(null);
  const [showPreflightBriefing, setShowPreflightBriefing] = useState(false);
  const [flightPlanWasFiled, setFlightPlanWasFiled] = useState(false);
  const [flightPlanFiled, setFlightPlanFiled] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const [alternateCharts, setAlternateCharts] = useState({});

  const [alternateRoute, setAlternateRoute] = useState(null);
  const [expandedPirep, setExpandedPirep] = useState(null);

  const [preflightResolved, setPreflightResolved] = useState(null);



  const { user } = useAuth();

  const createAndJoinMission = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("No token found");
      return;
    }

    const res = await fetch("https://ficon-x.com/route/create-mission", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: `${origin}-${destination}`
      })
    });

    const mission = await res.json();

    console.log("🧭 Mission created:", mission);

    const missionId = mission.id;

    // 💾 Save mission ID
    localStorage.setItem("activeMissionId", missionId);

    // 🔌 Join mission
    if (window.routeSocket) {
      window.routeSocket.emit("join_mission", {
        mission_id: String(missionId)
      });
    }

    // 🔗 Create share link
    const shareLink = `${window.location.origin}/?mission=${missionId}`;

    console.log("🔗 Share this link:", shareLink);

    // 📋 Copy to clipboard
    await navigator.clipboard.writeText(shareLink);

    alert("Mission created. Link copied to clipboard!");

  } catch (err) {
    console.error("❌ Mission create failed:", err);
  }
};

useEffect(() => {

  console.log(
    "🛬 PREFLIGHT RUNWAYS:",
    arrivalRunways
  );

}, [arrivalRunways]);

useEffect(() => {
  if (!route || !origin || !destination) return;

  let isCancelled = false;

  async function resolvePreflight() {
    console.log("🧠 Resolving preflight route...");

    const result = await resolveRouteWithCoords(
      route,
      origin,
      destination,
      altitude
    );

    if (!isCancelled) {
      console.log("✅ Preflight resolved:", result);

      // 🔥 Store globally for mission sharing BEFORE Start Flight
      window.currentPreflightRoute = result;

      console.log(
        "🧪 GLOBAL PREFLIGHT ROUTE:",
        window.currentPreflightRoute
      );

      console.log(
        "🧪 PREFLIGHT COORDS:",
        window.currentPreflightRoute?.coords
      );

      setPreflightResolved(result);
    }
  }

  resolvePreflight();

  return () => {
    isCancelled = true;
  };

}, [route, origin, destination, altitude]);

const dispatchedRouteKey =
  useRef(null);



function getRelativePosition(pLat, pLon, aLat, aLon, refName = "") {
  if (!pLat || !pLon) return null;

  const toRad = (deg) => deg * Math.PI / 180;
  const toDeg = (rad) => rad * 180 / Math.PI;

  const R = 3440; // NM

  // 🔥 If no airport reference, fallback to simple output
  if (!aLat || !aLon) {
    return "Position available (no reference)";
  }

  const dLat = toRad(pLat - aLat);
  const dLon = toRad(pLon - aLon);

  const lat1 = toRad(aLat);
  const lat2 = toRad(pLat);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  let bearing = (toDeg(Math.atan2(y, x)) + 360) % 360;

  const dirs = ["N","NE","E","SE","S","SW","W","NW"];
  const dir = dirs[Math.round(bearing / 45) % 8];

  return `${Math.round(distance)} NM ${dir}${refName ? ` of ${refName}` : ""}`;
}


const saveFlightToServer = async (flight) => {

  try {

    const token =
      localStorage.getItem("token");

    // =====================================
    // DEVELOPMENT MODE
    // =====================================

    if (!token) {

      console.warn(
        "🧪 DEV MODE: No token - skipping backend save."
      );

      return true;
    }

    const res = await fetch(
      "https://ficon-x.com/auth/save-flight",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(flight)
      }
    );

    if (!res.ok) {

      console.warn(
        "⚠️ Backend save failed:",
        res.status
      );

      return false;
    }

  const data = await res.json();

  console.log(
    "✅ Flight saved to backend",
    data
  );

  // =====================================
  // SAVE DATABASE FLIGHT ID
  // =====================================

  flight.meta.flightId = data.flightId;

  // Save updated active flight locally
  localStorage.setItem(
    "activeFlight",
    JSON.stringify(flight)
  );

  console.log(
    "🆔 Flight ID stored:",
    data.flightId
  );

  return true;

  }

  catch (err) {

    console.warn(
      "⚠️ Save failed:",
      err
    );

    return false;

  }

};

useEffect(() => {
  if (!destination || !alternateIcao) return;

  async function resolveAlt() {
    const result = await resolveRouteWithCoords(
      `${destination} ${alternateIcao}`,
      destination,
      alternateIcao,
      altitude
    );

    setAlternateRoute(result);
  }

  resolveAlt();
}, [destination, alternateIcao, altitude]); 

useEffect(() => {
  // Clear any stale shared mission unless user explicitly shares again
  localStorage.removeItem("lastSharedMissionId");
}, []);


useEffect(() => {
  // If user is not actively sharing, clear stale mission
  if (!showShareModal) {
    localStorage.removeItem("lastSharedMissionId");
  }
}, []);



  useEffect(() => {
    const handleScroll = () => {
      const el = briefingRef.current;
      if (!el) return;

      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;
      const scrolledToBottom = scrollTop + clientHeight >= scrollHeight - 100;
      setHideStickyBar(scrolledToBottom);
    };

    const el = briefingRef.current;
    if (el) {
      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }
  }, []);


const handleStartFlight = async () => {
  // =====================================
  // 🔐 LOGIN GATE
  // =====================================

  if (!user) {

    console.log("🔐 Login required");

    onRequireLogin?.();

    return;
  }

  console.log("✅ User authenticated");


  try {

    // =====================================
    // 1️⃣ RESOLVE ROUTE GEOMETRY
    // =====================================

console.log(
  "🚨 RESOLVE INPUTS",
  {
    route,
    origin,
    destination,
    altitude,

    selectedSidRunway,
    selectedSid,
    selectedSidTransition,

    selectedArrivalRunway,
    selectedStar,
    selectedStarTransition,

    selectedApproach,
    selectedArrivalIAF
  }
);

console.log(
  "🚨 START FLIGHT ROUTE VARIABLE:",
  route
);

console.log(
  "🚨 START FLIGHT FILED ROUTE:",
  filedRoute
);

const resolved =
  await resolveRouteWithCoords(

    filedRoute.join(" "),

    origin,

    destination,

    altitude,

    selectedSidRunway,

    selectedSid,
    selectedSidTransition,

    selectedArrivalRunway,

    selectedStar,
    selectedStarTransition,

    selectedApproach,
    selectedArrivalIAF
);

  console.log(
  "🚨 START FLIGHT ARRIVAL RUNWAY:",
  selectedArrivalRunway
);

  console.log(
  "🛬 START FLIGHT RESOLVED:",
  resolved
);

console.log(
  "🚨 START FLIGHT COORDOBJECT COUNT:",
  resolved?.coordObjects?.length
);

console.log(
  "🚨 START FLIGHT ALNZO:",
  resolved?.coordObjects?.find(
    x => x.name === "ALNZO"
  )
);

console.log(
  "🛬 START FLIGHT FIX COUNT:",
  resolved?.coords?.length
);

console.log(
  "🛬 START FLIGHT FIXES:",
  resolved?.coords?.map(
    x => x.name
  )
);

console.log(
  "🚨 RESOLVED WAYPOINTS:",
  resolved?.waypoints
);

console.log(
  "🚨 FIRST COORD:",
  resolved?.coords?.[0]
);

console.log(
  "🧪 RESOLVED NAMES:",
  resolved?.names
);

console.log(
  "🧪 FULL RESOLVED OBJECT:",
  resolved
);
    // =====================================
    // 2️⃣ COMPUTE BOUNDS
    // =====================================

    const lats =
      resolved.coords.map(
        c => c[1]
      );

    const lngs =
      resolved.coords.map(
        c => c[0]
      );

    const bounds = {

      north:
        Math.max(...lats),

      south:
        Math.min(...lats),

      east:
        Math.max(...lngs),

      west:
        Math.min(...lngs),
    };

    // =====================================
    // 3️⃣ BUILD STRUCTURED FLIGHT STATE
    // =====================================

    console.log(
  "🚨 ARRIVAL VARIABLES",
  {
    selectedArrivalRunway,
    selectedStar,
    selectedStarTransition,
    selectedApproach,
    selectedArrivalIAF
  }
);

    const activeFlight = {

      // =====================================
      // 🧠 STRUCTURED ROUTE MODEL
      // =====================================

routeStructure: {

  filedRoute:
    filedRoute || [],

  filedTokens:
    filedRoute || [],

  activeTokens:
    resolved.names || [],

  activeObjects:
    resolved.coordObjects || [],

        // 🛫 DEPARTURE
departure: {

  runway:
    selectedSidRunway || null,

  sid:
    typeof selectedSid !== "undefined"
      ? selectedSid
      : null,

  transition:
    typeof selectedSidTransition !== "undefined"
      ? selectedSidTransition
      : null
},

        // 🛣 ENROUTE
enroute: {

  routeText:

    Array.isArray(filedRoute)
      ? filedRoute.join(" ")
      : (filedRoute || ""),

  tokens:

    resolved.names || []
},

        // 🛬 ARRIVAL
arrival: {

  runway:
    selectedArrivalRunway || null,

  star:
    selectedStar || null,

  transition:
    selectedStarTransition || null,

  approach:
    selectedApproach || null,

  iaf:
    selectedArrivalIAF || null
}
      },

      // =====================================
      // ✈️ META
      // =====================================

      meta: {


        callsign,

        origin,
        destination,

        status: "ACTIVE",

        flightId: null,

        routeTextOriginal:
          route,

        routeTextCurrent:
          route,

        altitude,

        tas:
          Number(tas) || 0,

        burnRate:
          Number(burnRate) || 0,

        startedAt:
          Date.now(),

        // ✈️ AIRCRAFT

        aircraftType:
          aircraftType || "",

        cruiseMach:
          cruiseMach || "",

        // ⚖️ WEIGHTS

        zfw:
          Number(zfw) || 0,

        payload:
          Number(payload) || 0,

        mzfw:
          Number(mzfw) || 0,

        mtow:
          Number(mtow) || 0,

        mlw:
          Number(mlw) || 0,
      },

      // =====================================
      // 🛣 ROUTE
      // =====================================

      route: {

        coords:
          resolved.coords,

        waypoints:
          resolved.waypoints || [],

        totalDistanceNm:

          routeDistanceNm ||
          resolved.routeDistanceNm ||
          0,

        distanceRemainingNm:

          routeDistanceNm ||
          resolved.routeDistanceNm ||
          0,

        bounds,

        amendedHistory: []
      },

      // =====================================
      // ✈️ AIRCRAFT
      // =====================================

      aircraft: {

        currentLegIndex: 0,

        position:
          resolved.coords[0],

        heading: 0,

        groundSpeed:
          Number(tas) || 0,

        phase: "taxi"
      },

      // =====================================
      // ⛽ FUEL
      // =====================================

      fuel: {

        fuelStart:
          totalFuel || 0,

        burnRatePerHour:
          Number(burnRate) || 0,

        fuelUsed: 0,

        fuelRemaining:
          totalFuel || 0,

        reserveRequiredMinutes: 45,

        projectedFuelAtDestination:
          totalFuel || 0,

        // ✈️ EXTRA

        plannedTripBurn:
          enrouteFuel || 0,

        alternateFuel:
          alternateFuel || 0,

        contingencyFuel:
          contingency || 0,

        taxiOutFuel:
          taxiOut || 0,

        taxiInFuel:
          taxiIn || 0,
      },

      // =====================================
      // ⏱ TIMING
      // =====================================

      timing: {

        eteTotalMinutes:
          totalMinutes || 0,

        eteRemainingMinutes:
          totalMinutes || 0,

        elapsedMinutes: 0
      },

      // =====================================
      // 🟡 ALTERNATE
      // =====================================

      alternate: {

        icao:

          alternateIcao
            ?.toUpperCase()
            ?.trim() || null,

        route: null,

        visible: false,

        distanceNm: null,

        eteMinutes: null,

        mode:

          alternateIcao
            ? "planned"
            : null
      },

      // =====================================
      // 🔥 REQUIRED FOR MAPCOMPONENT
      // =====================================

      origin:
        resolved.coords[0],

      destination:
        resolved.coords[
          resolved.coords.length - 1
        ],

      waypoints:
        resolved.waypoints || []
    };

    // =====================================
    // 🧪 DEBUG
    // =====================================

    console.log(
      "🧪 START FLIGHT routeStructure:",
      activeFlight?.routeStructure
    );

    console.log(
      "🧪 START FLIGHT filedRoute:",
      activeFlight?.routeStructure
        ?.filedRoute
    );

    // =====================================
    // 4️⃣ STORE LOCALLY FIRST
    // =====================================

    window.__LAST_ACTIVE_FLIGHT = activeFlight;

    console.log(
      "🚨 ACTIVE FLIGHT WAYPOINTS:",
      activeFlight.route.waypoints
    );

    console.log(
      "🚨 ACTIVE FLIGHT NAMES:",
      activeFlight.routeStructure.enroute.tokens
    );

    console.log(
      "🚨 SAVED ARRIVAL:",
      activeFlight.routeStructure.arrival
    );

    console.log(
  "🚨 SAVED COORD NAMES",
  activeFlight.route.waypoints?.map(
    x => x.id || x.name
  )
);

console.log(
  "🚨 SAVING ACTIVE FLIGHT WAYPOINTS",
  activeFlight.route.waypoints?.map(
    w => w.id || w.name
  )
);

console.log(
  "🚨 SAVING DEPARTURE",
  activeFlight.routeStructure?.departure
);


localStorage.setItem(

  "activeFlight",

  JSON.stringify(activeFlight)
);
    

    sessionStorage.setItem(

      "flightSessionActive",

      "true"
    );

    console.log(
      "🚨 ABOUT TO SAVE FLIGHT",
      activeFlight
    );

    // =====================================
    // 5️⃣ SAVE TO BACKEND
    // =====================================

    const saved =
      await saveFlightToServer(
        activeFlight
      );

    console.log(
      "🚨 SAVE RESULT:",
      saved
    );

    // =====================================
    // 6️⃣ SEND INITIAL ROUTE TO MISSION
    // =====================================

    const missionId =
      localStorage.getItem(
        "activeMissionId"
      );

    if (
      saved &&
      missionId &&
      route
    ) {

      console.log(

        "📡 Sending initial route to mission:",

        route,

        "→",

        missionId
      );

      if (
        window.routeSocket
      ) {

        window.routeSocket.emit(

          "update_mission",

          {

            mission_id:
              String(missionId),

            state: {

              fullFlight: {

                ...activeFlight,

                timestamp:
                  Date.now()
              },

              route:
                route,

              coords:
                resolved.coords,

              waypoints:
                resolved.waypoints || []
            }
          }
        );

      } else {

        console.warn(
          "⚠️ routeSocket not found on window"
        );
      }
    }

// =====================================
// 7️⃣ START FLIGHT — RETURN TO LIVE MAP
// =====================================

if (saved) {

  console.log(
    "🚀 Flight saved — activating live flight"
  );

  window.__SIM_STARTED =
    true;

  // Do NOT reload the browser here.
  // activeFlight is already saved in localStorage.
  // Close Preflight and return to the existing Mapbox instance.

  if (onStartFlightComplete) {

    onStartFlightComplete();

  } else {

    console.warn(
      "⚠️ onStartFlightComplete callback missing"
    );

  }

} else {

  console.warn(
    "⚠️ Save failed — staying on page"
  );

  alert(
    "Flight save failed."
  );
}

} catch (err) {

  console.error(
    "Start Flight failed:",
    err
  );

  alert(err.message);
}
};



// ✅ Saved Charts tab preview
const renderSavedChartsTab = () => {

  if (

    !savedCharts ||

    savedCharts.length === 0

  ) return null;

  return (

    <section

      className="brief-section"

      style={{
        marginTop: 20
      }}
    >

      <h4>
        📁 Saved Charts
      </h4>

      <div
        style={{

          display: "flex",

          gap: 10,

          flexWrap: "wrap"
        }}
      >

        {savedCharts.map(
          (chart) => (

          <button

            key={chart.id}

            onClick={() =>
              onChartSelect(
                chart
              )
            }

            style={{

              padding:
                "6px 12px",

              borderRadius: 6,

              backgroundColor:
                "#333",

              color: "#fff",

              cursor: "pointer",

              border: "none",
            }}
          >

            {chart.name}

          </button>
        ))}
      </div>
    </section>
  );
};



const handleChartToggle = (chart) => {

  console.log(
    "🔁 Toggling chart:",
    chart
  );

  console.log(
    "📋 Previously saved:",
    savedCharts
  );

  // =====================================
  // 🔥 ENSURE TRUE UNIQUE ID
  // =====================================

  const chartWithId = {

    ...chart,

    id:

      chart.id ||

      Date.now() +

      "_" +

      Math.random()
  };

  // =====================================
  // 🔍 CHECK IF THIS EXACT CHART
  //    INSTANCE IS SAVED
  // =====================================

  const alreadySaved =
    savedCharts.some(

      c => c.id === chartWithId.id
    );

  // =====================================
  // 🗑 REMOVE
  // =====================================

  if (alreadySaved) {

    setSavedCharts(prev =>

      prev.filter(

        c => c.id !== chartWithId.id
      )
    );

    console.log(
      "🗑 Removed chart:",
      chartWithId.name
    );

  } else {

    // =====================================
    // 💾 SAVE
    // =====================================

    setSavedCharts(prev => [

      ...prev,

      chartWithId
    ]);

    console.log(
      "💾 Added chart:",
      chartWithId.name
    );
  }
};


function handleSaveCharts() {
  console.log("🧪 Saving charts:", savedCharts);

  if (!savedCharts || savedCharts.length === 0) {
    alert("No charts saved.");
    return;
  }

  // 🔥 THIS IS THE KEY LINE
  localStorage.setItem("savedCharts", JSON.stringify(savedCharts));

  console.log("🧪 Charts stored in localStorage");

  alert(`Saved ${savedCharts.length} charts.`);
}

useEffect(() => {
  const fetchCharts = async (icao, setter) => {
    if (!icao) return;

    console.log("🛫 Fetching charts for:", icao);

    try {
      const res = await fetch(`https://ficon-x.com/route/get_available_charts?icao=${icao}`);
      const data = await res.json();

      console.log("📊 Raw chart response:", data);

      if (!data || data.error) {
        console.warn(`⚠️ No charts returned for ${icao}`);
        setter({});
        return;
      }

      // 🔥 HANDLE BOTH POSSIBLE BACKEND FORMATS
      const normalizedCharts = data.charts || data;

      console.log("✅ Normalized charts:", normalizedCharts);

      setter(normalizedCharts);

    } catch (err) {
      console.error(`❌ Failed to fetch charts for ${icao}:`, err);
      setter({});
    }
  };

  // 🔥 Prevent loading flicker from multiple parallel calls
  setLoadingCharts(true);

  const runFetches = async () => {
    await Promise.all([
      fetchCharts(origin, setOriginCharts),
      fetchCharts(destination, setDestinationCharts),
      alternateIcao ? fetchCharts(alternateIcao, setAlternateCharts) : Promise.resolve()
    ]);

    setLoadingCharts(false);
  };

  runFetches();

}, [origin, destination, alternateIcao]);

  // --- METAR parser shared by both origin & destination ---
  function parseMetar(metar) {
    if (!metar) return {};
    const timeMatch = metar.match(/\d{6}Z/);
    const windMatch = metar.match(/(\d{3})(\d{2,3})G?(\d{0,3})KT/);
    const visMatch = metar.match(/(\d+SM)/);
    const cloudsMatch = metar.match(/(FEW|SCT|BKN|OVC)\d{3}/g);
    const tempMatch = metar.match(/ (\d{2})\/(M?\d{2}) /);
    const altMatch = metar.match(/A(\d{4})/);

    return {
      time: timeMatch?.[0] || "Unavailable",
      winds: windMatch
        ? `${windMatch[1]}° at ${windMatch[2]}KT${windMatch[3] ? ` G${windMatch[3]}KT` : ""}`
        : "N/A",
      visibility: visMatch?.[1] || "N/A",
      clouds: cloudsMatch?.join(" ") || "N/A",
      temperature: tempMatch?.[1] || "N/A",
      dewpoint: tempMatch?.[2] || "N/A",
      altimeter: altMatch?.[1] || "N/A",
    };
  }

const parsedOriginMetar =
  originData?.metar
    ? parseMetar(originData.metar)
    : null;

const parsedDestMetar =
  destinationData?.metar
    ? parseMetar(destinationData.metar)
    : null;


// =====================================
// TEMP DEBUG — PREFLIGHT DATA
// =====================================

console.log(
  "🧪 PREFLIGHT ORIGIN DATA:",
  originData
);

console.log(
  "🧪 PREFLIGHT DESTINATION DATA:",
  destinationData
);

console.log(
  "🧪 PREFLIGHT DEST METAR:",
  destinationData?.metar
);

console.log(
  "🧪 PREFLIGHT DEST TAF:",
  destinationData?.taf
);

console.log(
  "🧪 PREFLIGHT DEST NOTAMS:",
  destinationData?.notams
);

console.log(
  "🧪 PREFLIGHT DEST SUMMARY:",
  destinationData?.summary
);
const renderChartSection = (icao, charts) => {
  if (!charts || Object.keys(charts).length === 0) {
    return <p><em>No charts available for {icao}</em></p>;
  }

  return Object.entries(charts).map(([category, list]) => {
    if (!Array.isArray(list) || list.length === 0) return null;

    return (
      <div key={`${icao}-${category}`} style={{ marginBottom: 8 }}>
        <h5 style={{
          marginBottom: 6,
          fontSize: "15px",
          textTransform: "capitalize",
          fontWeight: 600,
          color: "#faf6f6ff",
          letterSpacing: "0.3px"
        }}>
          {category}
        </h5>

        <ul style={{ marginTop: 0, paddingLeft: "1rem", listStyle: "none" }}>
          {list.map((chart, i) => {
            if (!chart || !chart.url) return null;

            const fullChart = { ...chart, icao, category };

            // 🔥 FIXED MATCHING (URL only — name can vary)
const isChecked =
  savedCharts.some(
    (c) => c.url === fullChart.url
  );
            return (
              <li
                key={`${icao}-${category}-${i}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 4
                }}
              >
                {/* ✅ Checkbox */}
                <input
                  type="checkbox"
                  checked={isChecked}
onChange={() => {

  const exists =
    savedCharts.some(
      c => c.url === fullChart.url
    );

  if (exists) {

    setSavedCharts(prev =>
      prev.filter(
        c => c.url !== fullChart.url
      )
    );

    console.log(
      "🗑 Removed:",
      fullChart.name
    );

  } else {

    const chartToSave = {

      ...fullChart,

      id:
        Date.now() +
        "_" +
        Math.random()
    };

    setSavedCharts(prev => [

      ...prev,

      chartToSave
    ]);

    console.log(
      "💾 Saved:",
      fullChart.name
    );
  }
}}
                  
                  style={{ marginRight: 6 }}
                />

                {/* ✅ Click to open modal */}
                <span
                style={{ cursor: "pointer", color: "#fcfcfcff" }}
                onClick={() => {
                  console.log("🧪 CLICKED CHART OBJECT:", fullChart);
                  console.log("🧪 CLICKED CHART URL:", fullChart?.url);

                  onChartSelect({
                    name: fullChart.name,
                    url: fullChart.url,   // 🔥 explicitly pass URL
                    icao: fullChart.icao,
                    category: fullChart.category
                  });
                }}
                >
                  {chart.name || "Unnamed Chart"}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  });
};
// === Fuel & Time Calculations ===
// === Fuel & Time Calculations (with DEBUG) ===
const defaultTaxiOutMin = 5;
const defaultTaxiInMin = 3;
const defaultContingencyMin = 10;

const actualTaxiOutMin = taxiOutMinutes || defaultTaxiOutMin;
const actualTaxiInMin = taxiInMinutes || defaultTaxiInMin;
const actualContingencyMin = contingencyMinutes || defaultContingencyMin;

// Convert minutes → fuel
const taxiOutFromMin = (Number(taxiOutMinutes || 0) / 60) * Number(burnRate || 0);
const taxiInFromMin = (Number(taxiInMinutes || 0) / 60) * Number(burnRate || 0);
const contingencyFromMin = (Number(contingencyMinutes || 0) / 60) * Number(burnRate || 0);

// Combine manual lbs + calculated lbs
const taxiOut = Number(taxiOutBurn || 0) + taxiOutFromMin;
const taxiIn = Number(taxiInBurn || 0) + taxiInFromMin;
const contingency = Number(contingencyBurn || 0) + contingencyFromMin;


const tasUsed = Number(tas) || Number(enrouteHazards?.tas_kts) || 0;
const routeDistanceNm =
  Number(enrouteHazards?.routeDistanceNm) || 0;


const timeFromHazards = enrouteHazards?.flight_time_hr;
const timeFromCalculation = tasUsed > 0 ? (routeDistanceNm / tasUsed) : 0;
const totalFlightHours =
  Number(
    timeFromHazards ??
    timeFromCalculation ??
    0
  );
// ✈️ Trip Fuel
const enrouteFuel = Number(burnRate) * totalFlightHours;

// 🟡 Alternate Fuel (ONLY if alternate exists)
const alternateDistanceNm = alternateRoute?.routeDistanceNm || 0;

const computedAlternateDistanceNm =
  alternateDistanceNm ||
  (
    alternateRoute?.coords?.length > 1
      ? (() => {

          let dist = 0;

          for (
            let i = 1;
            i < alternateRoute.coords.length;
            i++
          ) {

            const [lon1, lat1] =
              alternateRoute.coords[i - 1];

            const [lon2, lat2] =
              alternateRoute.coords[i];

            const R = 3440;

            const toRad =
              (d) => d * Math.PI / 180;

            const dLat =
              toRad(lat2 - lat1);

            const dLon =
              toRad(lon2 - lon1);

            const a =
              Math.sin(dLat / 2) ** 2 +
              Math.cos(toRad(lat1)) *
              Math.cos(toRad(lat2)) *
              Math.sin(dLon / 2) ** 2;

            const c =
              2 * Math.atan2(
                Math.sqrt(a),
                Math.sqrt(1 - a)
              );

            dist += R * c;
          }

          return dist;

        })()
      : 0
  );

const alternateFlightHours =
  computedAlternateDistanceNm > 0
    ? Math.max(
        0.5, // 🔥 minimum 30 min alternate profile
        computedAlternateDistanceNm / tasUsed
      )
    : 0;

const alternateFuel =
  alternateFlightHours *
  Number(burnRate || 0);

// =====================================
// 🔴 FINAL RESERVE FUEL
// Pilot-selected reserve.
// Minutes and pounds are linked representations
// of the SAME reserve — never added together.
// =====================================

const reserveFuel =
  Number(reserveBurn || 0);

// 🛢 NEW TOTAL
const totalFuel =
  enrouteFuel +
  taxiOut +
  taxiIn +
  contingency +
  alternateFuel +
  reserveFuel;
const totalMinutes = totalFlightHours * 60;
console.log(
  "🕒 ETA HOURS:",
  totalFlightHours
);

const timeEnroute =
  totalMinutes > 0 ? `${totalMinutes.toFixed(1)} min` : "Unknown";

    // ✈️ WEIGHT CALCULATIONS
const takeoffFuel =
  Math.max(
    0,
    totalFuel - taxiOut
  );

const calculatedTow =
  (Number(zfw) || 0) +
  takeoffFuel;

const calculatedLdw =
  Math.max(
    0,
    calculatedTow -
    enrouteFuel
  );

// 🔍 DEBUG LOGGING
console.log("🛠 DEBUG TIME CALCS ====================");
console.log("📦 enrouteHazards:", enrouteHazards);
console.log("📏 routeDistanceNm:", routeDistanceNm);
console.log("🚀 tasUsed:", tasUsed);
console.log("⏱️ timeFromHazards:", timeFromHazards);
console.log("⏳ timeFromCalculation:", timeFromCalculation);
console.log("⏱️ totalFlightHours:", totalFlightHours);
console.log("🕐 totalMinutes:", totalMinutes);
console.log("⏰ timeEnroute (final):", timeEnroute);
console.log("🔥 enrouteFuel:", enrouteFuel);
console.log("🛬 taxiOut:", taxiOut);
console.log("🛫 taxiIn:", taxiIn);
console.log("⚠️ contingency:", contingency);
console.log("⛽ totalFuel:", totalFuel);
console.log("=======================================");


const handleFileFlightPlan = () => {
  const callsign = "N12345";
  const aircraftType = "B738/M";
  const equip = "SDFGRWY/S";
  const depTime = "1230";
  const tas = "N0450";
  const flightLevel = `F${parseInt(altitude, 10)}` || "F350";
  const ete = "0230";
  const dof = new Date().toISOString().slice(2, 10).replace(/-/g, "");

  const icaoMessage = `(FPL-${callsign}-IS
-${aircraftType}-${equip}
-${origin}${depTime}
-${tas}${flightLevel} ${route.replace(/\s+/g, " ")}
-${destination}${ete}
-PBN/B2C2D2S1 DOF/${dof} REG/${callsign} RMK/FICON6 DEMO FILE)`;

  setFiledIcaoText(icaoMessage);
  setShowFiledModal(true);
};

const handleConfirmFlightPlan = () => {
  if (!filedIcaoText) return;

  console.log("✉️ Simulating email send to toll77@gmail.com...");
  console.log("📄 Flight plan content:\n\n" + filedIcaoText);

  setTimeout(() => {
    alert("Flight plan filed successfully.");
    setFiledIcaoText("");
    setShowFiledModal(false);
    setShowPreflightBriefing(true);
    setFlightPlanFiled(true);  // ✅ THIS IS THE IMPORTANT FIX
  }, 1500);
};

return (

  <div
    className="preflight-briefing"
    ref={briefingRef}
  >

    <h2>🛫 Preflight Briefing</h2>

    {/* ===================================== */}
    {/* 🧭 OPERATIONAL ROUTE BAR */}
    {/* ===================================== */}

    {filedRoute?.length > 0 && (

      <div className="route-bar">

        {filedRoute.map((token, index) => (

          <div
            key={index}
            className="route-token"
          >
            {token}
          </div>
        ))}
      </div>
    )}

    {renderSavedChartsTab()}

 <section className="brief-section">

  <h4>🗺 Route Summary</h4>

  <p>
    <strong>Origin:</strong> {origin}
  </p>

  <p>
    <strong>Destination:</strong> {destination}
  </p>

  <p>
    <strong>Selected STAR:</strong>{" "}
    {selectedStar || "AUTO"}
  </p>

  <p>
    <strong>STAR Transition:</strong>{" "}
    {selectedStarTransition || "AUTO"}
  </p>

</section>

<section className="brief-section">

  <h4>🛫 Departure Planning</h4>
    {/* ========================= */}
    {/* DEPARTURE */}
    {/* ========================= */}



      <div
        style={{
          fontWeight: 700,
          marginBottom: 8,
          color: "#00d2ff"
        }}
      >
        DEPARTURE
      </div>

      {/* SID */}

      <select

        value={selectedSid}

        onChange={(e) => {

          const sid =
            e.target.value;

          setSelectedSid(
            sid
          );

          updateDepartureProcedure({

            sid
          });
        }}

        style={{

          width: "100%",
          marginBottom: 8
        }}
      >

        <option value="">
          SID (AUTO)
        </option>

{
  availableSids.map(
    (sid) => {

      const exits =
        sidExits?.[sid] || [];

      const label =
        exits.length > 0
          ? `${sid} → ${exits.join(", ")}`
          : sid;

      return (

        <option
          key={sid}
          value={sid}
        >
          {label}
        </option>

      );
    }
  )
}

      </select>

      {/* DEPARTURE RUNWAY */}

<select

  value={
    selectedSidRunway
  }

  onChange={(e) => {

    const runway =
      e.target.value;

    setSelectedSidRunway(
      runway
    );

    updateDepartureProcedure({

      runway

    });

  }}

  style={{

    width: "100%",

    marginBottom: 8

  }}

>

  <option value="">
    Departure Runway (Select if Shown)
  </option>

{
  (sidRunways || []).map(
      (rwy) => (

        <option

          key={rwy}

          value={rwy}

        >

          {rwy}

        </option>

      )
    )
  }

</select>

{/*
      SID TRANSITION — HIDDEN FOR MVP
      Underlying SID transition state/code retained for future use.

      <select

        value={
          selectedSidTransition
        }

        onChange={(e) => {

          const transition =
            e.target.value;

          setSelectedSidTransition(
            transition
          );

          updateDepartureProcedure({

            transition
          });
        }}

        style={{
          width: "100%"
        }}
      >

        <option value="">
          SID Transition (AUTO)
        </option>

        {
          sidTransitions.map(
            (t) => (

              <option
                key={t}
                value={t}
              >
                {t}
              </option>
            )
          )
        }

      </select>
*/}
</section>

<section
  className="brief-section"
  style={{
    marginTop: 24
  }}
>

  <h4>🛬 Arrival Planning</h4>

    {/* ========================= */}
    {/* ARRIVAL */}
    {/* ========================= */}

    <div>

      <div
        style={{
          fontWeight: 700,
          marginBottom: 8,
          color: "#00d2ff"
        }}
      >
        ARRIVAL
      </div>

      {/* STAR */}

      <select

        value={selectedStar}

        onChange={(e) => {

          const star =
            e.target.value;

          setSelectedStar(
            star
          );

          updateArrivalProcedure({

            star
          });
        }}

        style={{

          width: "100%",
          marginBottom: 8
        }}
      >

        <option value="">
          STAR (AUTO)
        </option>

        {
          availableStars.map(
            (star) => (

              <option
                key={star}
                value={star}
              >
                {star}
              </option>
            )
          )
        }

      </select>

      {/* STAR TRANSITION */}

      <select

        value={
          selectedStarTransition
        }

        onChange={(e) => {

          const transition =
            e.target.value;

          setSelectedStarTransition(
            transition
          );

          updateArrivalProcedure({

            transition
          });
        }}

        style={{

          width: "100%",
          marginBottom: 8
        }}
      >

        <option value="">
          STAR Transition (AUTO)
        </option>

        {
          starTransitions.map(
            (t) => (

              <option
                key={t}
                value={t}
              >
                {t}
              </option>
            )
          )
        }

      </select>

{/*
      RUNWAY — HIDDEN FOR MVP

      Arrival runway is determined by the selected approach.
      Underlying arrival runway state/code retained.

      <select

        value={
          selectedArrivalRunway
        }

        onChange={(e) => {

          const runway =
            e.target.value;

          setSelectedArrivalRunway(
            runway
          );

          updateArrivalProcedure({

            runway
          });
        }}

        style={{

          width: "100%",
          marginBottom: 8
        }}
      >

        <option value="">
          Runway (AUTO)
        </option>

        {
          arrivalRunways.map(
            (rwy) => (

              <option
                key={rwy}
                value={rwy}
              >
                {rwy}
              </option>
            )
          )
        }

      </select>
*/}

      {/* APPROACH */}

      <select

        value={
          selectedApproach
        }

        onChange={(e) => {

          const approach =
            e.target.value;

          setSelectedApproach(
            approach
          );

          updateArrivalProcedure({

            approach
          });
        }}

        style={{

          width: "100%",
          marginBottom: 8
        }}
      >

<option value="">
  Approach (AUTO)
</option>

{
  availableApproaches.map(
    (apch) => (

      <option
        key={apch.value}
        value={apch.value}
      >
        {apch.label}
      </option>
    )
  )
}

      </select>

      {/* IAF */}

      <select

        value={
          selectedArrivalIAF
        }

        onChange={(e) => {

          const iaf =
            e.target.value;

          setSelectedArrivalIAF(
            iaf
          );

          updateArrivalProcedure({

            iaf
          });
        }}

        style={{
          width: "100%"
        }}
      >

        <option value="">
          IAF Entry (AUTO)
        </option>

        {
          availableIAFs.map(
            (iaf) => (

              <option
                key={iaf}
                value={iaf}
              >
                {iaf}
              </option>
            )
          )
        }

      </select>

  </div>

</section>

<div style={{ height: 20 }} />

{/* === FLIGHT INFO === */}
<section className="brief-section">
  <h4>🧮 Flight Summary</h4>
  
  <p>
    <strong>⏱ Time Enroute:</strong> {timeEnroute}
  </p>

  <p>
    <strong>✈️ Trip Fuel:</strong> {Math.round(enrouteFuel).toLocaleString()} lbs
  </p>

  <p><strong>🛫 Cruise Altitude:</strong> FL{Math.round(altitude / 100)}</p>

  <p>
    <strong>Fuel Breakdown:</strong><br />
    🛫 Taxi Out: {Math.round(taxiOut).toLocaleString()} lbs<br />
    🛬 Taxi In: {Math.round(taxiIn).toLocaleString()} lbs<br />
    ⚠️ Contingency: {Math.round(contingency).toLocaleString()} lbs<br />
    🟡 Alternate: {Math.round(alternateFuel).toLocaleString()} lbs<br />
    🔴 Reserve: {Math.round(reserveFuel).toLocaleString()} lbs
  </p>

  <hr />

  <p>
    <strong>🛢 Total Fuel Required:</strong> {Math.round(totalFuel).toLocaleString()} lbs
  </p>
</section>



{/* === AIRCRAFT & WEIGHTS === */}
<section className="brief-section">

  <h4>✈️ Aircraft & Weights</h4>

  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit, minmax(220px, 1fr))",

      gap: "14px",
      marginTop: "12px"
    }}
  >

    {/* AIRCRAFT */}
    <div
      style={{
        background:
          "rgba(255,255,255,0.05)",

        padding: "12px",

        borderRadius: "10px"
      }}
    >

      <h5 style={{ marginTop: 0 }}>
        Aircraft
      </h5>

      <p>
        <strong>Type:</strong>{" "}
        {aircraftType || "---"}
      </p>

      <p>
        <strong>Cruise:</strong>{" "}

        {altitude
          ? `FL${Math.round(
              Number(altitude) / 100
            )}`
          : "---"}

        {cruiseMach
          ? ` / M${cruiseMach}`
          : ""}
      </p>

    </div>

    {/* CURRENT WEIGHTS */}
    <div
      style={{
        background:
          "rgba(255,255,255,0.05)",

        padding: "12px",

        borderRadius: "10px"
      }}
    >

      <h5 style={{ marginTop: 0 }}>
        Current Weights
      </h5>

      <p>
        <strong>ZFW:</strong>{" "}
        {zfw
          ? `${Number(zfw).toLocaleString()} lbs`
          : "---"}
      </p>

      <p>
        <strong>TOW:</strong>{" "}
        {calculatedTow
          ? `${Math.round(
              calculatedTow
            ).toLocaleString()} lbs`
          : "---"}
      </p>

      <p>
        <strong>LDW:</strong>{" "}
        {calculatedLdw
          ? `${Math.round(
              calculatedLdw
            ).toLocaleString()} lbs`
          : "---"}
      </p>

    </div>

    {/* LIMITS */}
    <div
      style={{
        background:
          "rgba(255,255,255,0.05)",

        padding: "12px",

        borderRadius: "10px"
      }}
    >

      <h5 style={{ marginTop: 0 }}>
        Aircraft Limits
      </h5>

      <p>
        <strong>MZFW:</strong>{" "}
        {mzfw
          ? `${Number(mzfw).toLocaleString()} lbs`
          : "---"}
      </p>

      <p>
        <strong>MTOW:</strong>{" "}
        {mtow
          ? `${Number(mtow).toLocaleString()} lbs`
          : "---"}
      </p>

      <p>
        <strong>MLW:</strong>{" "}
        {mlw
          ? `${Number(mlw).toLocaleString()} lbs`
          : "---"}
      </p>

    </div>

    {/* PAYLOAD */}
    <div
      style={{
        background:
          "rgba(255,255,255,0.05)",

        padding: "12px",

        borderRadius: "10px"
      }}
    >

      <h5 style={{ marginTop: 0 }}>
        Payload
      </h5>

      <p>
        <strong>Payload:</strong>{" "}
        {payload
          ? `${Number(payload).toLocaleString()} lbs`
          : "---"}
      </p>

      {calculatedTow && mtow && (
        <p>
          <strong>MTOW Margin:</strong>{" "}
          {`${(
            Number(mtow) -
            calculatedTow
          ).toLocaleString()} lbs`}
        </p>
      )}

      {calculatedLdw && mlw && (
        <p>
          <strong>MLW Margin:</strong>{" "}
          {`${(
            Number(mlw) -
            calculatedLdw
          ).toLocaleString()} lbs`}
        </p>
      )}

    </div>

  </div>

</section>

{/* === OPERATIONAL INSIGHT === */}
<section className="brief-section">

  <h4>🧠 Operational Insight</h4>

  {calculatedTow && mtow && (
    <p>
      ✈️ Aircraft operating at{" "}
      {Math.round(
        (calculatedTow /
          Number(mtow)) *
          100
      )}
      % of MTOW.
    </p>
  )}

  {calculatedLdw && mlw && (
    <p>
      🛬 Estimated landing weight leaves{" "}
      {(
        Number(mlw) -
        calculatedLdw
      ).toLocaleString()} lbs
      below MLW.
    </p>
  )}

  {reserveFuel > 0 &&
    burnRate > 0 && (
      <p>
        ⛽ Reserve endurance approximately{" "}
        {(
          reserveFuel /
          burnRate
        ).toFixed(1)}{" "}
        hours.
      </p>
  )}

  {alternateFuel > 0 && (
    <p>
      🟡 Alternate fuel included for{" "}
      {alternateIcao || "planned alternate"}.
    </p>
  )}

</section>

      {/* === DEPARTURE === */}
      <section className="brief-section">
        <h4>📍 Departure: {origin}</h4>

{/* METAR */}
{parsedOriginMetar ? (
  <>
    <h5>🟢 Current METAR</h5>

    {/* 🔥 RAW METAR */}
    <div
      style={{
        marginTop: 6,
        marginBottom: 12,
        padding: "10px 12px",
        borderRadius: 10,
        background: "rgba(255,255,255,0.05)",
        fontFamily: "monospace",
        fontSize: "13px",
        lineHeight: "1.5",
        color: "#dff4ff",
        overflowWrap: "break-word",
        border: "1px solid rgba(255,255,255,0.06)"
      }}
    >
      {originData?.metar}
    </div>

    {/* 🔥 PARSED BREAKDOWN */}
    <div style={{ fontSize: "0.9em", color: "#ccc" }}>
      <div><strong>Time:</strong> {parsedOriginMetar.time}</div>
      <div><strong>Winds:</strong> {parsedOriginMetar.winds}</div>
      <div><strong>Visibility:</strong> {parsedOriginMetar.visibility}</div>
      <div><strong>Clouds:</strong> {parsedOriginMetar.clouds}</div>
      <div><strong>Temperature:</strong> {parsedOriginMetar.temperature}</div>
      <div><strong>Altimeter:</strong> {parsedOriginMetar.altimeter}</div>
    </div>
  </>
) : <p><em>No METAR available</em></p>}

        {/* TAF */}
        <h5>📅 TAF</h5>
        {originData?.taf ? (
          Array.isArray(originData.taf) ? (
            <ul>{originData.taf.map((entry, i) => <li key={i}>{entry}</li>)}</ul>
          ) : (
            <p>{originData.taf}</p>
          )
        ) : (
          <p><em>Unavailable</em></p>
        )}

        {alternateData && (
          <div style={{ marginTop: 40 }}>
            <h3 style={{ color: "#FFA500" }}>
              Alternate Airport ({alternateData.icao})
            </h3>

            <p>{alternateData.metar}</p>
            <p>{alternateData.taf}</p>

            <h4>NOTAM Summary</h4>
            <p>{alternateData.notamSummary}</p>

            <h4>PIREPs</h4>
            {alternateData.pireps?.map((p, i) => (
              <div key={i} style={{ fontSize: "12px", marginBottom: "4px" }}>
                {p.raw_text}
              </div>
            ))}
          </div>
        )}
                

        {/* PIREPs */}
        {originData?.pireps?.length > 0 && (
          <>
            <h5>📡 Nearby PIREPs</h5>
            <ul>
              {originData.pireps.map((p, i) => (
                <li key={i}>
                  {p.turbulence && <>🟡 TURB {p.flight_level ? `FL${p.flight_level}` : ""}</>}
                  {p.icing_condition && <> ❄️ ICE {p.icing_condition}</>}
                  {p.sky_condition && <> ☁️ SKY {p.sky_condition}</>}
                </li>
              ))}
            </ul>
          </>
        )}
      </section>

{/* === ARRIVAL === */}
<section className="brief-section">
  <h4>🎯 Arrival: {destination}</h4>

{/* =========================
    PRIMARY: ETA FORECAST (AVIATION MODE)
========================= */}
<div style={{
  marginTop: 8,
  marginBottom: 14,
  padding: "10px 12px",
  backgroundColor: "#0a2a33",
  borderRadius: "8px",
  border: "1px solid #00d4ff33"
}}>

  {/* HEADER */}
  <div style={{
    fontSize: "0.9em",
    color: "#00d4ff",
    fontWeight: "bold",
    marginBottom: 6
  }}>
    🕒 Forecast at ETA ({Math.floor(totalFlightHours)}h {Math.round((totalFlightHours % 1) * 60)}m)
  </div>

  {/* CONTENT */}
  {(() => {
    const eta = destinationData?.eta_weather;

    console.log(
  "🌦 ETA WEATHER:",
  destinationData
);

    if (!destinationData) {
      return <div style={{ color: "#888" }}>Loading arrival data...</div>;
    }

    if (!eta) {
      return <div style={{ color: "#888" }}>Calculating forecast...</div>;
    }

    // 🔥 PRIORITY 1 — RAW TAF SEGMENT (BEST SOURCE)
    if (eta.raw) {
      return (
        <div style={{ fontSize: "0.95em", lineHeight: "1.5em" }}>
          
          {/* RAW LINE */}
          <div style={{
            fontFamily: "monospace",
            background: "rgba(0,0,0,0.35)",
            padding: "6px 8px",
            borderRadius: 6,
            marginBottom: 6,
            color: "#00ffcc"
          }}>
            {eta.raw}
          </div>

          {/* BREAKDOWN */}
          {eta.winds && <div>✔ Winds: <strong>{eta.winds}</strong></div>}
          {eta.visibility && <div>✔ Visibility: <strong>{eta.visibility}</strong></div>}
          {eta.clouds && <div>✔ Clouds: <strong>{eta.clouds}</strong></div>}
          {eta.weather && <div>⚠️ Weather: <strong>{eta.weather}</strong></div>}

        </div>
      );
    }

    // 🔥 FALLBACK — STRUCTURED DATA ONLY (NO INTERPRETATION)
    return (
      <div style={{ fontSize: "0.95em", lineHeight: "1.5em" }}>

        {eta.winds && <div>✔ Winds: <strong>{eta.winds}</strong></div>}
        {eta.visibility && <div>✔ Visibility: <strong>{eta.visibility} SM</strong></div>}
        {eta.ceiling && <div>✔ Ceiling: <strong>{eta.ceiling} ft</strong></div>}
        {eta.clouds && <div>✔ Clouds: <strong>{eta.clouds}</strong></div>}
        {eta.weather && <div>⚠️ Weather: <strong>{eta.weather}</strong></div>}

        {!eta.winds && !eta.visibility && !eta.ceiling && (
          <div style={{ color: "#aaa" }}>
            Forecast data limited
          </div>
        )}

      </div>
    );
  })()}

</div>

  {/* =========================
      SECONDARY: CURRENT METAR
  ========================= */}
  {parsedDestMetar ? (
    <div style={{ marginBottom: 14 }}>
      <h5 style={{ marginBottom: 6 }}>🟢 Current METAR</h5>

      <div style={{ fontSize: "0.9em", color: "#ccc" }}>
        <div><strong>Time:</strong> {parsedDestMetar.time}</div>
        <div><strong>Winds:</strong> {parsedDestMetar.winds}</div>
        <div><strong>Visibility:</strong> {parsedDestMetar.visibility}</div>
        <div><strong>Clouds:</strong> {parsedDestMetar.clouds}</div>
        <div><strong>Temperature:</strong> {parsedDestMetar.temperature}</div>
        <div><strong>Altimeter:</strong> {parsedDestMetar.altimeter}</div>
      </div>
    </div>
  ) : (
    <p><em>No METAR available</em></p>
  )}

  {/* =========================
      TERTIARY: TAF
  ========================= */}
  <div style={{ marginBottom: 14 }}>
    <h5 style={{ marginBottom: 6 }}>📅 TAF</h5>

    {destinationData?.taf ? (
      Array.isArray(destinationData.taf) ? (
        <ul style={{ marginTop: 0 }}>
          {destinationData.taf.map((entry, i) => (
            <li key={i} style={{ fontSize: "0.85em", color: "#aaa" }}>{entry}</li>
          ))}
        </ul>
      ) : (
        <p style={{ fontSize: "0.85em", color: "#aaa" }}>{destinationData.taf}</p>
      )
    ) : (
      <p><em>Unavailable</em></p>
    )}
  </div>

{/* =========================
    PIREPs (PILOT MODE UI)
========================= */}
{(originPireps.length === 0 && destinationPireps.length === 0) ? (
  <>
    <h5>📡 Nearby PIREPs</h5>
    <p style={{ fontSize: 14 }}>None reported within 100 NM.</p>
  </>
) : (
  <>
    <h5>📡 Nearby PIREPs</h5>

    {/* ================= ORIGIN ================= */}
    {originPireps.length > 0 && (
      <>
        <h6 style={{ marginBottom: 4 }}>🛫 Near Departure ({origin})</h6>
        <ul style={{ marginTop: 0, paddingLeft: 16 }}>
          {originPireps.map((p, i) => {
            const key = `origin-${i}`;
            const isOpen = expandedPirep === key;

            // 🔥 USE BACKEND VALUE
            const location = p.relative_position || "Position reported";

            const severityIcon =
              p.turbulence?.toLowerCase().includes("sev") ? "🔴" :
              p.turbulence?.toLowerCase().includes("mod") ? "🟡" :
              p.turbulence?.toLowerCase().includes("lgt") ? "🟢" :
              "⚪";

            return (
              <li
                key={key}
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  marginBottom: 6
                }}
                onClick={() => setExpandedPirep(isOpen ? null : key)}
              >
                🕒 {p.time ? `${p.time}Z` : "Unknown"} — ✈️ {p.aircraft_type || "Unknown"}

                {/* PRIMARY LINE */}
                <div style={{ fontSize: 13, marginTop: 2 }}>
                  {p.turbulence && (
                    <span>{severityIcon} TURB {p.flight_level ? `FL${p.flight_level}` : ""} </span>
                  )}
                  {p.icing_condition && (
                    <span>❄️ ICE {p.icing_condition} </span>
                  )}
                  {p.sky_condition && (
                    <span>☁️ {p.sky_condition} </span>
                  )}
                  {!p.turbulence && !p.icing_condition && !p.sky_condition && (
                    <span>General PIREP </span>
                  )}
                 
                </div>

                {/* EXPANDED */}
                {isOpen && (
                  <div
                    style={{
                      marginTop: 6,
                      padding: "6px 10px",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid #444",
                      borderRadius: 6,
                      fontSize: 12
                    }}
                  >
                    <div><strong>Altitude:</strong> {p.flight_level ? `FL${p.flight_level}` : "N/A"}</div>
                    <div><strong>Location:</strong> {location}</div>
                    <div><strong>Turbulence:</strong> {p.turbulence || "None"}</div>
                    <div><strong>Icing:</strong> {p.icing_condition || "None"}</div>
                    <div><strong>Sky:</strong> {p.sky_condition || "N/A"}</div>
                    <div><strong>Visibility:</strong> {p.visibility || "N/A"}</div>
                    <div><strong>Remarks:</strong> {p.raw_text || "None"}</div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </>
    )}

    {/* ================= DESTINATION ================= */}
    {destinationPireps.length > 0 && (
      <>
        <h6 style={{ marginBottom: 4 }}>🛬 Near Arrival ({destination})</h6>
        <ul style={{ marginTop: 0, paddingLeft: 16 }}>
          {destinationPireps.map((p, i) => {
            const key = `dest-${i}`;
            const isOpen = expandedPirep === key;

            // 🔥 USE BACKEND VALUE
            const location = p.relative_position || "Position reported";

            const severityIcon =
              p.turbulence?.toLowerCase().includes("sev") ? "🔴" :
              p.turbulence?.toLowerCase().includes("mod") ? "🟡" :
              p.turbulence?.toLowerCase().includes("lgt") ? "🟢" :
              "⚪";

            return (
              <li
                key={key}
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  marginBottom: 6
                }}
                onClick={() => setExpandedPirep(isOpen ? null : key)}
              >
                🕒 {p.time ? `${p.time}Z` : "Unknown"} — ✈️ {p.aircraft_type || "Unknown"}

                {/* PRIMARY LINE */}
                <div style={{ fontSize: 13, marginTop: 2 }}>
                  {p.turbulence && (
                    <span>{severityIcon} TURB {p.flight_level ? `FL${p.flight_level}` : ""} </span>
                  )}
                  {p.icing_condition && (
                    <span>❄️ ICE {p.icing_condition} </span>
                  )}
                  {p.sky_condition && (
                    <span>☁️ {p.sky_condition} </span>
                  )}
                  {!p.turbulence && !p.icing_condition && !p.sky_condition && (
                    <span>General PIREP </span>
                  )}
                 
                </div>

                {/* EXPANDED */}
                {isOpen && (
                  <div
                    style={{
                      marginTop: 6,
                      padding: "6px 10px",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid #444",
                      borderRadius: 6,
                      fontSize: 12
                    }}
                  >
                    <div><strong>Altitude:</strong> {p.flight_level ? `FL${p.flight_level}` : "N/A"}</div>
                    <div><strong>Location:</strong> {location}</div>
                    <div><strong>Turbulence:</strong> {p.turbulence || "None"}</div>
                    <div><strong>Icing:</strong> {p.icing_condition || "None"}</div>
                    <div><strong>Sky:</strong> {p.sky_condition || "N/A"}</div>
                    <div><strong>Visibility:</strong> {p.visibility || "N/A"}</div>
                    <div><strong>Remarks:</strong> {p.raw_text || "None"}</div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </>
    )}
  </>
)}
</section>

{/* === NOTAMs Section === */}
{(originData?.notams?.length > 0 || destinationData?.notams?.length > 0 ||
  originData?.summary || destinationData?.summary) && (
  <section className="brief-section">
    <h4>📢 Airport NOTAMs</h4>
    <p style={{ fontSize: 13, color: "#ffffffff" }}>
      NOTAMs are summarized in plain language for quick pilot briefing. 
      Use the toggle below to view the official FAA text when needed.
    </p>

    {/* ORIGIN SUMMARY */}
    {originData?.summary && (
      <div style={{ marginBottom: 12 }}>
        <h5>🛫 {origin} Summary</h5>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            fontSize: 13,
            background: "rgba(255,255,255,0.05)",
            padding: "8px 10px",
            borderRadius: "6px",
          }}
        >
          {originData.summary}
        </pre>
      </div>
    )}

{/* ORIGIN RAW */}
{Array.isArray(originData?.notams) && originData.notams.length > 0 && (
  <ToggleableNotamList
    airportCode={origin}
    notams={originData.notams}
    label="Origin NOTAMs"
  />
)}

    {/* DEST SUMMARY */}
    {destinationData?.summary && (
      <div style={{ marginBottom: 12 }}>
        <h5>🛬 {destination} Summary</h5>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            fontSize: 13,
            background: "rgba(255,255,255,0.05)",
            padding: "8px 10px",
            borderRadius: "6px",
          }}
        >
          {destinationData.summary}
        </pre>
      </div>
    )}

    {/* DEST RAW */}
    {destinationData?.notams?.length > 0 && (
      <ToggleableNotamList
        airportCode={destination}
        notams={destinationData?.notams || []}
        label="Destination NOTAMs"
      />
    )}
  </section>
)}

<section className="brief-section">
  <h4>⚠️ Enroute Hazards</h4>

  <p>
    <strong>SmartHazard Score:</strong>{" "}
    {enrouteHazards?.hazard_score
      ? enrouteHazards.hazard_score.toFixed(2)
      : "TBD"}
  </p>

  <p>
    <strong>Average Risk:</strong>{" "}
    {enrouteHazards?.hazard_avg
      ? enrouteHazards.hazard_avg.toFixed(2)
      : "TBD"}
  </p>

  <p>
    <strong>Max Risk:</strong>{" "}
    {enrouteHazards?.hazard_max
      ? enrouteHazards.hazard_max.toFixed(2)
      : "TBD"}
  </p>

  <p>
    <strong>Route Distance:</strong>{" "}
    {enrouteHazards?.routeDistanceNm
      ? `${Math.round(enrouteHazards.routeDistanceNm)} NM`
      : "TBD"}
  </p>
</section>

<section className="brief-section">
  <h4>🗺️ Airport Charts</h4>

  {loadingCharts && <p><em>Loading charts...</em></p>}

  <div style={{ display: "flex", gap: 30, flexWrap: "wrap" }}>

    {/* 🛫 ORIGIN */}
    <div>
      <h5>🛫 {origin}</h5>
      {renderChartSection(origin, originCharts)}
    </div>

    {/* 🛬 DESTINATION */}
    <div>
      <h5>🛬 {destination}</h5>
      {renderChartSection(destination, destinationCharts)}
    </div>

    {/* 🟠 ALTERNATE */}
    {alternateIcao && Object.keys(alternateCharts || {}).length > 0 && (
      <div>
        <h5 style={{ color: "#FFA500" }}>
          🟠 {alternateIcao}
        </h5>

        {/* 🔥 NEW: ETA CONTEXT */}
        {totalFlightHours && (
          <div style={{
            marginTop: 4,
            marginBottom: 8,
            fontSize: "0.85em",
            color: "#FFA500",
            fontWeight: "bold"
          }}>
            🕒 Evaluated at ETA ({Math.floor(totalFlightHours)}h {Math.round((totalFlightHours % 1) * 60)}m)
          </div>
        )}

        {/* 🔥 OPTIONAL: ETA WEATHER DISPLAY (if you pass it later) */}
        {destinationData?.alternate_eta_weather && (
          <div style={{
            marginBottom: 10,
            fontSize: "0.9em",
            color: "#fff"
          }}>
            ✔ Visibility: {destinationData.alternate_eta_weather.visibility} SM <br />
            ✔ Ceiling: {destinationData.alternate_eta_weather.ceiling} ft
          </div>
        )}

        {/* EXISTING CHARTS (UNCHANGED) */}
        {renderChartSection(alternateIcao, alternateCharts)}
      </div>
    )}

  </div>

  {savedCharts.length > 0 && (
    <button
      onClick={handleSaveCharts}
      style={{
        marginTop: 16,
        padding: "6px 14px",
        fontSize: 14,
        backgroundColor: "#2b6cb0",
        color: "#fff",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      💾 Save Selected Charts ({savedCharts.length})
    </button>
  )}
</section>





<div className={`sticky-action-bar ${hideStickyBar ? "hidden" : ""}`}>
  <button
    className="action-btn"
    onClick={handleFileFlightPlan}
    disabled={flightPlanFiled}
    style={flightPlanFiled ? { backgroundColor: "#1f6f3f", color: "white" } : {}}
  >
    <Send size={18} style={{ marginRight: 6 }} />
    {flightPlanFiled ? "Flight Plan Filed" : "File Flight Plan (coming soon)"}
  </button>

<button
  className="action-btn"
  onClick={() => {

    console.log("🚀 START BUTTON CLICKED");

    console.log("USER:", user);

    if (!user) {

      console.log("🔐 OPENING AUTH MODAL");

      onRequireLogin?.();

      return;
    }

    console.log("✈️ CALLING handleStartFlight()");

    handleStartFlight();

  }}
>
  <PlayCircle size={18} style={{ marginRight: 6 }} />
  Start Flight
</button>



  <button className="action-btn" onClick={() => window.print()}>
    <Printer size={18} style={{ marginRight: 6 }} />
    Print Briefing
  </button>

      <button
        className="action-btn"
        onClick={() => {
          setShowShareModal(true);
        }}
      >
        <Share2 size={18} style={{ marginRight: 6 }} />
        Share - In dev
      </button>



      {showShareModal && (
  <ShareFlightModal
    missionData={{
      origin,
      destination,
      route,
      altitude,
      tas,
      burnRate,
      timeEnroute,
      totalFuel,
      charts_selected: savedCharts,
      weather: {
        origin: originData?.metar,
        destination: destinationData?.metar,
        tafOrigin: originData?.taf,
        tafDestination: destinationData?.taf,
        notamsOrigin: originData?.notamSummary,
        notamsDestination: destinationData?.notamSummary,
        enroute: enrouteHazards
      },
      timestamp: Date.now()
    }}
    onClose={() => setShowShareModal(false)}
  />
)}

</div>

<div className="scroll-action-bar" style={{ marginTop: 40, paddingBottom: 80 }}>
  <button
    className="action-btn"
    onClick={handleFileFlightPlan}
    disabled={flightPlanFiled}
    style={flightPlanFiled ? { backgroundColor: "#1f6f3f", color: "white" } : {}}
  >
    <Send size={18} style={{ marginRight: 6 }} />
    {flightPlanFiled ? "Flight Plan Filed" : "File Flight Plan (coming soon)"}
  </button>

<button
  className="action-btn"
  onClick={() => {

    console.log("🚀 START BUTTON CLICKED");

    console.log("USER:", user);

    if (!user) {

      console.log("🔐 OPENING AUTH MODAL");

      onRequireLogin?.();

      return;
    }

    console.log("✈️ CALLING handleStartFlight()");

    handleStartFlight();

  }}
>
  <PlayCircle size={18} style={{ marginRight: 6 }} />
  Start Flight
</button>


  <button className="action-btn" onClick={() => window.print()}>
    <Printer size={18} style={{ marginRight: 6 }} />
    Print Briefing
  </button>



</div>

{showFiledModal && (
  <div className="chart-modal">
    <div className="chart-modal-header">
      <span>Filed Flight Plan</span>
      <button
        className="chart-close-btn"
        onClick={() => setShowFiledModal(false)}
      >
        Close
      </button>
    </div>

    <div
      style={{
        padding: "16px",
        whiteSpace: "pre-wrap",
        overflowY: "auto",
        color: "#e8e8e8",
        fontFamily: "monospace",
        fontSize: "13px",
        maxHeight: "400px",
      }}
    >
      <p><strong>Email To:</strong> 1800wxbrief@leidos.com</p>
      <p><strong>Subject:</strong> ICAO Flight Plan Filing</p>
      <p><strong>Message Body:</strong></p>
      <code>{filedIcaoText}</code>
    </div>

    <div
      style={{
        padding: "12px 16px 24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <button
        className="chart-save-btn"
        onClick={() => {
          navigator.clipboard.writeText(filedIcaoText);
          alert("ICAO message copied to clipboard");
        }}
      >
        Copy Message
      </button>

      <button
        className="chart-save-btn"
        onClick={() => {
          handleConfirmFlightPlan();
          setShowFiledModal(false);
          setFlightPlanFiled(true);
        }}
      >
        ✅ Confirm & File
      </button>
    </div>
  </div>
)}



    </div> // closes .preflight-briefing
  );
}

